import { useBlockProps } from "@wordpress/block-editor";

export default function Save({ attributes }) {
  const { title, selectedPosts, showDate } = attributes;
  
  const blockProps = useBlockProps.save({
    className: 'disaster-related-posts-block'
  });

  return (
    <div {...blockProps}>
      <div className="related-posts-section mt-16">
        <h2 className="text-3xl font-bold text-secondary-900 mb-8" 
            dangerouslySetInnerHTML={{ __html: title }} />
        
        {selectedPosts.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {selectedPosts.map((post) => (
              <article key={post.id} className="related-post bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
                
                {post.featured_media && (
                  <div className="post-image">
                    <a href={post.link}>
                      <img 
                        src={wp.media.attachment(post.featured_media).get('url')} 
                        className="w-full h-48 object-cover"
                        alt={post.title}
                      />
                    </a>
                  </div>
                )}
                
                <div className="post-content p-6">
                  {showDate && (
                    <div className="post-meta text-sm text-gray-500 mb-2">
                      {new Date(post.date).toLocaleDateString()}
                    </div>
                  )}
                  
                  <h3 className="post-title text-lg font-bold mb-3 text-secondary-900">
                    <a href={post.link} className="hover:text-primary transition-colors">
                      <span dangerouslySetInnerHTML={{ __html: post.title }} />
                    </a>
                  </h3>
                  
                  {post.excerpt && (
                    <div className="post-excerpt text-gray-600 mb-4">
                      <span dangerouslySetInnerHTML={{ __html: post.excerpt }} />
                    </div>
                  )}
                  
                  <a href={post.link} 
                     className="inline-flex items-center text-primary font-semibold hover:underline"
                     aria-label={`Read more about ${post.title}`}>
                    Read more
                    <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                    </svg>
                  </a>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
